import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'
import users from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'

interface IPaymentItem {
  [key: string]: any
}

class PaymentItem extends Model<IPaymentItem> {
  constructor(attr: IPaymentItem = {}) {
    super(attr)
    makeObservable(this, {
      employee: computed,
    })
  }

  static urlRoot() {
    return '/payroll/payment_items'
  }

  get employee(): Employee | null | undefined {
    if (!this.has('employee_id')) return null

    return employees.get(this.attributes.employee_id)
  }

  get fullName(): string {
    if (this.employee) {
      const user = users.get(this.employee.attributes.access_id)
      if (user)
        return getFullDisplayName({
          firstName: user.attributes.first_name,
          lastName: user.attributes.last_name,
          canSharePreferredName: this.employee.policy.can('sharePreferredName'),
          preferredName: this.employee.attributes.preferred_name,
        })
    }

    return this.attributes.full_name
  }
}

export default PaymentItem
